import React, { useState, useEffect, useRef } from "react";
import { Button, Box, Typography } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { toast } from "react-toastify";
import VideoPreview from "./VideoPreview";

const supportedFileTypes = [
  "mp4",
  "avi",
  "mov",
  "wmv",
  "mkv",
  "flv",
  "webm",
  "mpeg",
  "mpg",
  "3gp",
  "mts",
  "m2ts",
  "hevc",
  "h265",
  "mpd",
];

const UploadVideo = ({ setGoalVideos, index, goalVideos, Admin_user_cond }) => {
  const [preview, setPreview] = useState(() =>
    goalVideos[index].goal
      ? goalVideos[index].goal instanceof File
        ? URL.createObjectURL(goalVideos[index].goal)
        : goalVideos[index].goal
      : null,
  );
  const videoRef = useRef();
  const formRef = useRef();

  useEffect(() => {
    if (formRef.current) {
      if (!goalVideos[index].goal) {
        formRef.current.reset();
      }
    }
  }, [goalVideos, videoRef]);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    let files = [];
    if (e.target.files) {
      files = e.target.files;
    } else if (e.dataTransfer.files) {
      files = e.dataTransfer.files;
    }

    if (file) {
      const fileType = file.type.split("/")[1];
      const fileExt = file.name.split(".").pop().toLowerCase();
      if (
        !supportedFileTypes.includes(fileType) &&
        !supportedFileTypes.includes(fileExt)
      ) {
        toast.error(`File : ${file.name} type not supported`);
        return;
      }

      // console.log(
      //   file,
      //   "this file is selected file and the orignal name will be in backend be ?"
      // );

      setPreview(URL.createObjectURL(file));
      setGoalVideos((prev) =>
        prev.map((p, i) =>
          i == index
            ? { ...p, goal: file, created: true, checked: true }
            : { ...p },
        ),
      );
    } else {
      setGoalVideos((prev) =>
        prev.map((p, i) =>
          i == index
            ? { ...p, goal: null, edited: true, checked: false }
            : { ...p },
        ),
      );

    }
  };

  return (
    <>
      <Box className="">
        <Box className={"upload-video"}>
          {preview ? (
            <Box className="multiple-videos">
              <VideoPreview
                preview={preview}
                setPreview={setPreview}
                setGoalVideos={setGoalVideos}
                index={index}
                Admin_user_cond={Admin_user_cond}
              />
            </Box>
          ) : (
            <Button
              className="upload-btn"
              onClick={() => {
                if (videoRef.current) {
                  videoRef.current.click();
                } else {
                }
              }}
              sx={{ color: "#ef364e" }}
            >
              <FileUploadIcon className="file-upload-icon" />
              <Typography className="">Upload Video</Typography>
            </Button>
          )}
          <form ref={formRef}>
            <input
              type="file"
              accept="video/*"
              className="form-control"
              name="videoFile"
              id="video"
              style={{ display: "none" }}
              ref={videoRef}
              onChange={handleVideoChange}
            />
          </form>
        </Box>
      </Box>
    </>
  );
};

export default UploadVideo;
